module.exports = __webpack_public_path__ + "static/media/sound1.25b3bfe2.mp3";